import React from 'react'
import { Link } from 'gatsby'
import Layout from '../components/layout'
import DCSound from '../components/csounditem'
import useScript from '../components/usescript'
import { Row, Col } from "react-bootstrap";
const IndexPage = () => {

return (
  <Layout>
    <Col>
      <Row><Col><h2>Random Minimal Electro Music</h2></Col></Row>
      <Row><Col> <DCSound/></Col></Row>
    </Col>
  </Layout>
)
}

export default IndexPage
